var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-cards-parent"},[_c('SfHeading',{staticClass:"category-cards-heading",attrs:{"title":_vm.title,"description":_vm.description,"level":"2"}}),_vm._v(" "),_c('div',{staticClass:"category-cards-wrapper"},_vm._l((_vm.items),function(ref){
var label = ref.label;
var link = ref.link;
var image = ref.image;
var backgroundLabel = ref.backgroundLabel;
return _c('CategoryCard',{key:label,staticClass:"category-cards-wrapper-child",attrs:{"label":label,"link":link,"image":image,"backgroundLabel":_vm.getGridBackground(backgroundLabel)}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }